import {
  HStack,
  Icon,
  SkeletonText,
  Stack,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { HeaderTransaction } from "../../constants/Transaction";
import { RiBankCard2Line } from "@remixicon/react";
import { formatDate } from "../../utils/helperFunction";
import { useBgHover, useDarkWhiteColor } from "../../themes/colors";
import { PaymentProofModal } from "../dashboard_buyer_page/PaymentProofModal";
import { ReadMore } from "./ReadMore";

interface Props {
  data: HeaderTransaction | undefined;
  pageType: number;
  loaded: boolean;
}

export const DetailOrderHeader = ({
  data,
  pageType,
  loaded,
  ...rest
}: Props) => {
  const bgHover = useBgHover();
  const bg = useDarkWhiteColor();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openModalPaymentProof = () => {
    onOpen();
  };

  return (
    <>
      <VStack
        w={"100%"}
        p={4}
        bg={bg}
        align={"stretch"}
        borderRadius={"md"}
        {...rest}
      >
        <HStack w={"100%"} justify={"space-between"}>
          <Text textStyle={"h-reg-title"}>Pesanan</Text>

          {pageType === 1 && (
            <HStack
              as={"button"}
              className="status-order"
              py={1}
              px={2}
              _hover={{ bg: bgHover }}
              borderRadius={["md"]}
              onClick={openModalPaymentProof}
              color={"yellow.600"}
            >
              <Icon as={RiBankCard2Line} />

              <Text textStyle={"b-reg-sb"}>Lihat Bukti Pembayaran</Text>
            </HStack>
          )}
        </HStack>

        <Stack
          w={"100%"}
          mt={2}
          direction={["column", "row"]}
          gap={0}
          justify={"space-between"}
        >
          <Text textStyle={"b-reg"}>Tranksasi Id</Text>

          <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
            <Text textStyle={"b-reg-sb"}>{data?.invoice}</Text>
          </SkeletonText>
        </Stack>

        <Stack
          w={"100%"}
          direction={["column", "row"]}
          gap={0}
          justify={"space-between"}
        >
          <Text textStyle={"b-reg"}>Tanggal Pembelian</Text>

          <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
            <Text textStyle={"b-reg"}>
              {data && data.date && formatDate(data.date.toString())}
            </Text>
          </SkeletonText>
        </Stack>

        {data?.reason && (
          <Stack
            w={"100%"}
            direction={["column", "row"]}
            gap={0}
            justify={"space-between"}
          >
            <Text textStyle={"b-reg"}>Keterangan Ditolak</Text>

            <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
              <ReadMore
                textAlign={"end"}
                data={data.reason}
                maxLength={100}
                maxW={["120px", null, "300px", "500px"]}
              />
            </SkeletonText>
          </Stack>
        )}
      </VStack>

      <PaymentProofModal
        orderId={data?.id}
        invoice={data?.invoice}
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        children={undefined}
      />
    </>
  );
};
